module.exports = __webpack_public_path__ + "static/logo-garmin-pay-0aec025a82e884ae6189f066ec3cb12b.svg";